window.addEventListener('DOMContentLoaded', () => {
    let extension = document.querySelector('.main__extension');
    let uploader = document.querySelector('.uploader');
    let field = uploader.querySelector('.uploader__field');
    let input = uploader.querySelector('.field__input');
    let dataTransfer = new DataTransfer();

    const createItem = (title) => {
        let item = uploader.querySelector('.list__item').cloneNode(true);

        item.querySelector('.item__title').innerText = title;
        item.querySelector('.item__icon--cross').addEventListener('click', () => {
            dataTransfer.items.remove(Array.from(item.parentNode.children).indexOf(item) - 1);
            input.files = dataTransfer.files;
            item.remove();
        });

        uploader.querySelector('.uploader__list').append(item);
    };

    input.addEventListener('change', (event) => {
        event.preventDefault();

        let files = event.target.files;

        for (let i = 0; i < files.length; i++) {
            if (files[i].type === 'application/pdf') {
                dataTransfer.items.add(files[i]);
                createItem(files[i].name);
            }
        }

        input.files = dataTransfer.files;

        uploader.classList.remove('uploader--invalid');

        if (extension) {
            extension.style.display = 'block';
        }
    });

    field.addEventListener('drop', (event) => {
        event.preventDefault();

        let files = event.dataTransfer.files;

        for (let i = 0; i < files.length; i++) {
            if (files[i].type === 'application/pdf') {
                dataTransfer.items.add(files[i]);
                createItem(files[i].name);
            }
        }

        input.files = dataTransfer.files;

        uploader.classList.remove('uploader--invalid');
        uploader.classList.remove('uploader--active');

        if (extension) {
            extension.style.display = 'block';
        }
    });

    field.addEventListener('dragenter', (event) => {
        event.preventDefault();

        uploader.classList.add('uploader--active');
    });

    field.addEventListener('dragover', (event) => {
        event.preventDefault();

        uploader.classList.add('uploader--active');
    });

    field.addEventListener('dragleave', (event) => {
        event.preventDefault();

        uploader.classList.remove('uploader--active');
    });
});